module.exports = __webpack_public_path__ + "img/homepagebgd.f7842cf6.png";